<template>
    <search-group :span="24" :btnOffset="20" :multipleLines="true" :inline="true"  @search="findData" @clear="clearValue" >
        <Row class="mb16" :gutter="16">
            <Col span="6">
                 <Select v-model="searchData.projectFid" placeholder="请选择项目">
                    <Option v-for="item in projectList" :value="item.value" :key="item.value">{{item.text}}</Option>
                </Select>
            </Col>
            <Col span="6">
              <DatePicker v-model="predictCollectDate" split-panels type="daterange" format="yyyy-MM-dd" @on-clear="clearDate" @on-change="changePredictCollectDate" placeholder="计划收款日期"></DatePicker>
            </Col>
            <Col span="6">
                 <Select v-model="searchData.billType" placeholder="费用项" >
                    <Option value=''>请选择</Option>
                    <Option v-for="item in billType" :value="item.value" :key="item.value">{{item.text}}</Option>
                </Select>
            </Col>
            <Col span="6">
                 <Select v-model="searchData.verificateStatus" placeholder="单据状态">
                   <Option value=''>请选择</Option>
                    <Option v-for="item in verificateStatus" :value="item.value" :key="item.value">{{item.text}}</Option>
                </Select>
            </Col>
          <!--<Col span="4">-->
            <!--<Select v-model="searchData.billListType" placeholder="账单类型">-->
              <!--<Option value=''>请选择</Option>-->
              <!--<Option v-for="item in billTypeList" :value="item.value" :key="item.value">{{item.text}}</Option>-->
            <!--</Select>-->
          <!--</Col>-->


        </Row>
      <Row class="mb16" :gutter="16">
        <Col span="4">
          <Select v-model="key" placeholder="关键字查询">
            <Option value=''>请选择</Option>
            <Option v-for="item in keyList" :value="item.value" :key="item.value">{{item.text}}</Option>
          </Select>
        </Col>
        <Col span="6">
          <Input type="text" v-model="keyValue" placeholder="请输入" @keyup.enter.native="findData"></Input>
        </Col>
      </Row>
    </search-group>
</template>

<script type="text/ecmascript-6">
import {formatDateTime} from '@/utils/format'
import { getProjects } from 'api/common'
import { getConditions } from 'api/accountsReceivable'

export default {
    props:{

    },
    created(){
      this.initData()
    },
    watch:{

    },
    data () {
      return {
        billTypeList:[{text:'出房',value:0},{text:'解约',value:1}],
        billType:[],
        verificateStatus:[],
        loading:false,
        projectList:[],
        predictCollectDate:[],
        surApplicationDate:[],
        key:'',
        keyValue:'',
        keyList:[
          {
            value:'stockNumber',
            text:'房间号'
          },
          {
            value:'contractCode',
            text:'合同号'
          },
          {
            value:'preContractCode',
            text:'预订单号'
          },
          {
            value:'customerName',
            text:'客户名称'
          },
          {
            value:'billNumber',
            text:'账单编号'
          },
          {
            value:'surCode',
            text:'解约协议编号'

          }
        ],
        searchData:{
          projectFid:'',
          predictCollectDateStart:'',
          predictCollectDateEnd:'',
          billType:'',
          verificateStatus:'',
          // billListType:'',

          limit: 10,
          page: 1
        }
      }
    },
    methods: {
      findData() {
        let key = this.key
        let value = this.keyValue
        let data = {}
        if(key && value) {
          data[key] = value
        }
        data = Object.assign({},data, this.searchData);
        this.$emit('findData',data)
      },
      changePredictCollectDate(val){

        let end = new Date(val[1]).valueOf() - 8*3600*1000 // 减掉8小时
        let lastMonth = this.getLastMonth(new Date(val[0]))

        if(end > lastMonth){
          this.predictCollectDate = [val[0],formatDateTime(lastMonth,false)]
          this.$Modal.warning({
            title: '消息提醒',
            content: '查询时间跨度不得大于1个月！'
          });
        }
        this.searchData.predictCollectDateStart = typeof this.predictCollectDate[0] ==='object' ? formatDateTime(this.predictCollectDate[0],false) : this.predictCollectDate[0]
        this.searchData.predictCollectDateEnd = typeof this.predictCollectDate[1]==='object' ? formatDateTime(this.predictCollectDate[1],false) : this.predictCollectDate[1]
      },
      clearValue() {
        for (var key in this.searchData) {
          if(key === 'limit' || key === 'projectFid') continue
          if(key === 'page'){
            this.searchData[key] = 1
            continue;
          }
          this.searchData[key] = ''
        }
        this.initDate()
        this.key = ''
        this.keyValue = ''
      },
      clearDate(){
        this.searchData.predictCollectDateStar = ''
        this.searchData.predictCollectDateEnd = ''
      },
      getLastMonth(curDay){
        //let start = new Date(curDay)
        let year = curDay.getFullYear()
        let month = curDay.getMonth()+1
        let day = curDay.getDate()-1
        return new Date(year,month,day).valueOf()
      },
      initDate(){
        let start  = formatDateTime(new Date(), false)
        let lastMonth = this.getLastMonth(new Date())
        let end =formatDateTime(lastMonth ,false)
        this.predictCollectDate = [start, end]
        this.searchData.predictCollectDateStart = start
        this.searchData.predictCollectDateEnd = end
      },
      initData(){
        getConditions().then( res => {
          this.billType = res.data.billType
          this.verificateStatus =  res.data.verificateStatus
        })
        getProjects().then( res => {
          this.projectList = res.data
          this.searchData.projectFid = this.projectList[0].value
          this.initDate()
          this.$emit('findData',this.searchData)
        })
      }
    }
}
</script>
<style scoped>
.dash {
  text-align: center;
}
.dash span {
  display: inline-block;
  width: 60%;
  height: 2px;
  background: #dddee1;
  vertical-align: middle;
}
.ivu-date-picker {
  width: 100%;
}
</style>

